"use strict";
import { COLORS } from "./chartColors";
export const jobPublishedToFirstApplicationTransformer = (data, selectedEntities) => {
  const monthlyAverages = {};
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id, year, month] = key.split("_");
    const monthLabel = `${year}-${month.padStart(2, "0")}`;
    const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
    const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
      (entity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      const jobData = value.data.reduce(
        (acc, record) => {
          if (!record.id) return acc;
          if (!acc[record.id]) {
            acc[record.id] = {
              times: []
            };
          }
          if (record.published_to_hired) {
            const value2 = parseFloat(record.published_to_hired);
            if (!isNaN(value2)) {
              acc[record.id].times.push(value2);
            }
          }
          return acc;
        },
        {}
      );
      const allTimes = Object.values(jobData).flatMap((job) => job.times).filter(Boolean);
      if (allTimes.length > 0) {
        const average = allTimes.reduce((sum, time) => sum + time, 0) / allTimes.length;
        monthlyAverages[monthLabel] = parseFloat((average / (24 * 60 * 60)).toFixed(1));
      }
    } else if (!value.data.reportNotFound) {
      return;
    }
  });
  const sortedLabels = Object.keys(monthlyAverages).sort();
  return {
    labels: sortedLabels,
    datasets: [
      {
        label: "Average time (Days)",
        data: sortedLabels.map((label) => monthlyAverages[label]),
        borderWidth: 1,
        backgroundColor: COLORS[0],
        fill: false
      }
    ]
  };
};
